import { Box, ListItem, ListItemButton, Stack, Typography } from "@mui/material"
import noop from "lib/noop"
import { BadgeLabel } from "routes/regime/plugins/regime-title/badge-label"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { setDraftStatusBadgeColor } from "../scoped-schedules/lib/set-draft-status-badge-color"

export function ScheduleListRow({ schedule, onClick = noop, showPublishedInfo = false, ...props }) {
    const { code, title, isDraft, status, version } = schedule
    const badgeColor = getBadgeColor()
    const badgeLabel = getBadgeLabel()
    const publishedInfo = formatPublishedInfo()
    const isInteractive = onClick !== noop

    if (isInteractive) {
        return (
            <ListItemButton onClick={onClick} {...props}>
                {renderRowContent()}
            </ListItemButton>
        )
    }

    return (
        <ListItem
            {...props}
            sx={{
                borderRadius: 1,
                mx: 0.5,
                my: 0.25,
                px: 2,
                py: 1.5,
                "&:hover": { bgcolor: "action.hover" },
            }}
        >
            {renderRowContent()}
        </ListItem>
    )

    function renderRowContent() {
        return (
            <Stack direction="row" spacing={2} alignItems="center" sx={{ width: 1 }}>
                <Iconify icon={"quill:paper"} sx={{ width: 24, height: 24, color: "text.secondary" }} />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography variant="subtitle2" noWrap>
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" noWrap>
                        #{code}
                    </Typography>
                    <If truthy={showPublishedInfo}>
                        <Typography variant="caption" color="text.secondary" noWrap data-cy="schedule-published-info">
                            {publishedInfo}
                        </Typography>
                    </If>
                </Box>
                <BadgeLabel variant="subtitle2" sx={{ zoom: 0.8 }} color={badgeColor}>
                    {badgeLabel}
                </BadgeLabel>
            </Stack>
        )
    }

    function getBadgeColor() {
        if (!isDraft) return "warning"
        return setDraftStatusBadgeColor(status)
    }

    function getBadgeLabel() {
        if (!isDraft) return "No Draft"
        return status?.titleize()
    }

    function formatPublishedInfo() {
        const versionLabel = version ? `Current published version: v${version}` : null
        const publishedDate = parsePublishedDate(schedule?.metadata?.published)
        const publishedLabel = publishedDate
            ? `Published ${publishedDate.format(DATE_FORMATS.medium)}`
            : "Not yet published"
        return [versionLabel, publishedLabel].filter(Boolean).join(" · ")
    }

    function parsePublishedDate(published) {
        if (!published) return null
        const date = new Date(published)
        return Number.isNaN(date.getTime()) ? null : date
    }
}
